import { THEME_VARIANTS } from '../theme-variant';

const overridePaper = (theme) => {
  theme.overrides.MuiPaper = {
    root: {
      position: 'relative'
    },
    rounded: {
      borderRadius: theme.sizes.roundCorners
    }
  };
  // Reskin: papers round like cards, but menus and popovers stay tighter.
  if (theme.themeVariant === THEME_VARIANTS.RESKIN) {
    // MUI Cards used directly (not through core Card) get the outlined card too.
    theme.overrides.MuiPaper.elevation1 = { boxShadow: 'none' };
    theme.overrides.MuiCard = {
      root: theme.cardStyles.outlined
    };
    theme.overrides.MuiPopover = {
      paper: {
        borderRadius: theme.sizes.innerCorners
      }
    };
  }
};

export default overridePaper;
